<template>
  <v-container fluid class="investstock-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Stock</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Stock</p>
                        <v-text-field
                          class="mb-4"
                          type="Number"
                          v-model="new_investstock.stockrank"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Stock Rank"
                          persistent-hint
                          single-line hint="Enter the stock rank">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_investstock.stockcode"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Stock Code"
                          persistent-hint
                          single-line hint="Enter the stock Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_investstock.stockname"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Stock Name"
                          persistent-hint
                          single-line hint="Enter the stock name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=investstock_types
                          v-model="new_investstock.stocktype"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the stock type">
                        </v-select>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md=12>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/investstock/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertInvestStock()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      new_investstock: {},
      investstock_types: ['Stock', 'CEF', 'ETF'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('InvestStock', ['isReceiving']),
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('InvestStock', ['insertInvestStockRequest','getInvestStocksRequest']),
    checkError(){
      if(!this.new_investstock.stockrank){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_investstock.stockcode){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_investstock.stockname){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.new_investstock.stocktype){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertInvestStock() {
      await this.insertInvestStockRequest(this.new_investstock)
      router.push('/investstock/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.new_investstock.investstockimage = file;
      this.new_investstock.imagename = file.name;
      this.createImage(file);
    }
  },
  async created(){
    if(this.accounts.length==0) await this.getAccountsRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
